const translation = {
  Product: "Produto",
  "Header.productNav": "Produto LUKKEY",
  Feature: "Funcionalidade",
  "About Us": "Sobre nós",
  FAQ: "Perguntas frequentes",
  "Privacy Policy": "Política de privacidade",
  "Help Center": "Centro de ajuda",
  "Header.infoMenu": "Mais",
  "Header.appNow": "Obter o app",
  "Header.appModal.title": "Use o app da LUKKEY agora",
  "Header.appModal.subtitle": "Escolha sua plataforma para obter o app móvel oficial da LUKKEY.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Instale o app oficial no iPhone.",
  "Header.appModal.iosButton": "Abrir",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Obtenha o app oficial para Android no Google Play.",
  "Header.appModal.googlePlayButton": "Abrir",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Baixe diretamente o APK oficial mais recente.",
  "Header.appModal.androidButton": "Baixar",
  "Header.appModal.note": "Somente downloads móveis oficiais. Use os links acima para obter a versão mais recente.",
  "Academy": "Academia",
  "Legal": "Legal",
  "AboutUs.title": "Sobre a LUKKEY",
  "AboutUs.lede": "A LUKKEY é uma marca suíça de carteiras de hardware dedicada a construir o mais alto padrão de segurança para a posse de ativos digitais.",
  "AboutUs.vision.closing": "Suas chaves. Seus ativos. Seu futuro.",
  "AboutUs.quote": "A LUKKEY constrói a camada de segurança entre as pessoas e os ativos digitais.",
  "AboutUs.block1": "A LUKKEY está sediada na Suíça. A empresa se concentra em hardware wallets projetadas para autocustódia segura.",
  "AboutUs.block2": "Seus produtos combinam elementos seguros, proteção antiviolação e uma arquitetura totalmente offline. O objetivo é manter as chaves privadas em um ambiente isolado.",
  "AboutUs.block3": "O sistema foi projetado sem Wi‑Fi, USB ou dependência direta de rede. Acesso por impressão digital, ferramentas de backup NFC e amplo suporte a ativos o tornam prático no uso diário.",
  "AboutUs.block5": "A LUKKEY adota uma abordagem aberta e auditável para firmware e software centrais. As alegações de segurança devem permanecer inspecionáveis e verificáveis.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Solicitação de suporte",
  "WarrantySupport.intro": "Preencha as informações abaixo para enviar sua solicitação de suporte.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Resumo do problema",
  "WarrantySupport.form.issueTitle.placeholder": "Digite um resumo breve",
  "WarrantySupport.form.warrantyType.label": "Tipo de solicitação",
  "WarrantySupport.form.warrantyType.placeholder": "Selecione o tipo de solicitação",
  "WarrantySupport.form.warrantyType.product": "Problema no dispositivo",
  "WarrantySupport.form.warrantyType.service": "Problema no app/conta",
  "WarrantySupport.form.warrantyType.replacement": "Outro",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Descreva o problema ou a solicitação em detalhes",
  "WarrantySupport.form.submit": "Enviar solicitação de suporte",
  "WarrantySupport.alert.success": "Sua solicitação de suporte foi enviada!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Centro de ajuda",
  "HelpCenter.intro":
    "Bem-vindo à Central de Ajuda da LUKKEY! Se você é novo em criptomoedas ou precisa de ajuda com sua cold wallet, você está no lugar certo. Nossa solução de cold wallet oferece a forma mais segura de armazenar e gerenciar seus ativos digitais. Abaixo, você encontrará respostas para algumas das perguntas mais comuns e dicas de solução de problemas.",
  "HelpCenter.section4.title": "Precisa de mais ajuda?",
  "HelpCenter.section4.intro":
    "Economize tempo iniciando sua solicitação de suporte online e vamos conectar você a um especialista. Por segurança, o suporte oficial nunca pedirá sua frase de recuperação ou chave privada:",
  "HelpCenter.contact.hint": "Use o botão para enviar uma solicitação de suporte e entraremos em contato por e-mail.",
  "HelpCenter.cta.warranty": "Enviar solicitação de suporte",
  brandName: "LUKKEY",
  tagline: "Gerencie sua criptomoeda como nunca antes",
  description:
    "Comece sua jornada para a liberdade financeira com nosso aplicativo. Proteja seus ativos com nossa tecnologia avançada de carteira fria e gerencie suas finanças de maneira mais inteligente e eficaz. Seu bem-estar financeiro é nossa prioridade.",
  "home.seoTitle": "LUKKEY | Carteira de hardware suíça para autocustódia segura",
  "home.seoDescription": "A LUKKEY é uma marca suíça de carteiras de hardware focada em segurança de cold wallet, proteção offline de chaves privadas, acesso por impressão digital e backup via NFC para uma autocustódia segura.",
  learnMore: "Saiba mais",
  "Lock Your Crypto, Securely": "Bloqueie sua criptomoeda com segurança",
  Testimonials: "Depoimentos",
  Testimonial1:
    "Estou usando esta carteira fria há meses e estou impressionado com sua confiabilidade e recursos de segurança. Altamente recomendada!",
  Testimonial2:
    "Esta carteira fria superou minhas expectativas! Sua interface fácil de usar e segurança de ponta a tornam uma ferramenta indispensável para qualquer pessoa séria sobre criptomoedas.",
  Testimonial3:
    "Já tentei várias carteiras frias antes, mas esta se destaca. Seu design elegante e recursos avançados tornam a gestão dos meus ativos criptográficos muito fácil.",
  "John Doe": "John Doe",
  "Cryptocurrency Enthusiast": "Entusiasta de criptomoedas",
  "Jane Smith": "Jane Smith",
  "Crypto Security Advocate": "Advogado de Segurança de Criptomoedas",
  "Alex Johnson": "Alex Johnson",
  "Investment Analyst": "Analista de Investimentos",
  "Touchscreen Interface": "Interface de tela sensível ao toque",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Experimente o gerenciamento de criptomoedas sem esforço com nossa interface intuitiva de tela sensível ao toque, projetada para navegação rápida e fácil pelos seus ativos digitais, possibilitando transações rápidas e gerenciamento seguro ao seu alcance.",
  "Bluetooth Connectivity": "Conectividade Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Sincronização sem fio com seus dispositivos para atualizações em tempo real.",
  "Airtag Tracking": "Rastreamento com Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Rastreie sua carteira facilmente com o Airtag embutido.",
  "Secure Chip Technology": "Tecnologia de chip seguro",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Equipado com um chip de segurança avançado, garantindo proteção robusta para seus valiosos ativos digitais contra acesso não autorizado e ameaças cibernéticas.",
  "Cross-Platform Support": "Suporte multiplataforma",
  "Works with various platforms for easy accessibility.":
    "Funciona com várias plataformas para fácil acessibilidade.",
  AboutUsDescription1:
    "Na LUKKEY, estamos dedicados a fornecer soluções de alta qualidade para gerenciar seus ativos em criptomoedas de forma segura.",
  AboutUsDescription2:
    "Nossa sede está em Zug, Suíça. Com uma equipe de profissionais experientes, nos esforçamos para inovar e nos adaptar ao mercado em constante mudança das moedas digitais.",
  BlockchainNetworksSupported: "Redes Blockchain Suportadas",
  CryptocurrenciesSupported: "Suportando Mais de 6.000 Criptomoedas",
  Years: "Anos",
  ExpertiseInSecurity: "de experiência em segurança",
  FrequentlyAskedQuestions: "Perguntas frequentes",
  WhatIsColdWallet: "O que é uma Cold Wallet?",
  ColdWalletDescription:
    "Uma cold wallet é um tipo de carteira de criptomoeda que armazena seus ativos digitais offline, tornando-os menos vulneráveis a hacks e outras ameaças online. Diferente das hot wallets, que estão conectadas à internet e são convenientes para transações frequentes, as cold wallets são mais adequadas para armazenamento a longo prazo, pois oferecem segurança aprimorada.",
  HowToSetUpColdWallet: "Como configurar sua Cold Wallet?",
  ColdWalletSetupDescription:
    "Configurar sua cold wallet normalmente envolve inicializar o dispositivo em uma máquina segura e offline. Você precisará gerar e armazenar com segurança uma frase de recuperação, que é essencial para acessar seus ativos em caso de perda ou falha do dispositivo. Instruções detalhadas são fornecidas com a compra, garantindo um processo de configuração tranquilo.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Quais criptomoedas são compatíveis com suas cold wallets?",
  CryptocurrenciesCompatibilityDescription:
    "Nossas cold wallets suportam uma ampla gama de criptomoedas, incluindo as principais como Bitcoin, Ethereum e Litecoin, bem como várias altcoins. Para uma lista completa de moedas compatíveis, visite nosso site ou consulte a documentação do produto.",
  HowToSecureColdWallet: "Como garantir que minha cold wallet esteja segura?",
  ColdWalletSecurityDescription:
    "Para garantir a segurança da sua cold wallet, mantenha sempre a frase de recuperação em um local seguro e privado, nunca compartilhe com ninguém e considere usar medidas de segurança adicionais, como bloqueios biométricos ou caixas seguras. Atualizar regularmente o firmware da carteira a partir do site oficial também ajuda a proteger contra vulnerabilidades.",
  ColdWalletNotWorking:
    "O que devo fazer se minha cold wallet não estiver funcionando ou se eu encontrar um erro?",
  ColdWalletErrorDescription:
    "Se você tiver problemas com sua cold wallet, consulte a seção de solução de problemas no guia do usuário. Para problemas mais específicos, entre em contato com nossa equipe de suporte por meio do nosso site. Certifique-se de ter as informações do seu dispositivo à mão para agilizar o processo de suporte.",
  Community: "Comunidade",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "Junte-se à nossa comunidade na sua plataforma favorita para ficar atualizado, fazer perguntas e conectar-se com outros usuários.",
  "Subscribe.title": "Receba atualizações do produto",
  "Subscribe.subtitle":
    "Nós acompanhamos as tendências cripto por você. Receba atualizações de produto, insights de mercado e benefícios exclusivos — direto na sua caixa de entrada.",
  "Subscribe.placeholder": "Digite seu e-mail",
  "Subscribe.button": "Assinar atualizações do produto",
  "Subscribe.input.aria": "Campo de entrada de endereço de e-mail",
  "Subscribe.success":
    "Obrigado por assinar! Verifique seu e-mail de confirmação.",
  "Subscribe.error": "Falha na assinatura. Tente novamente mais tarde.",
  "Subscribe.invalid": "Insira um endereço de e-mail válido.",
  "Subscribe.privacy":
    "Seu e-mail será usado apenas para enviar nossa newsletter e atualizações. Você pode cancelar a assinatura a qualquer momento pelo link incluído na newsletter.",
  "Subscribe.learnMore":
    "Saiba mais sobre como gerenciamos seus dados e seus direitos.",
  "Subscribe.popupCompact.title": "Fique por dentro",
  "Subscribe.popupCompact.subtitle":
    "Atualizações do produto e insights de segurança. Sem spam.",
  "Subscribe.popupCompact.button": "Assinar",
  "Subscribe.popupCompact.privacy":
    "Somente e-mail. Cancele quando quiser.",
  "SubscribeConfirmed.alt.success": "Assinatura confirmada",
  "SubscribeConfirmed.alt.failed": "Falha na assinatura",
  "SubscribeConfirmed.title.success": "Assinatura confirmada",
  "SubscribeConfirmed.title.failed": "Falha na assinatura",
  "SubscribeConfirmed.message.success":
    "Obrigado por confirmar seu e-mail. Sua assinatura está ativa. Um e-mail de boas-vindas foi enviado para sua caixa de entrada.",
  "SubscribeConfirmed.message.failed":
    "O link de confirmação é inválido ou expirou. Volte à página inicial e tente assinar novamente.",
  "SubscribeConfirmed.cta.backHome": "Voltar para a página inicial",
  "SubscribeConfirmed.note.unsubscribe":
    "Você pode cancelar a assinatura a qualquer momento através do link em nossos e-mails.",
  // ===== MarketView i18n =====
  "MarketView.title": "Painel de mercado",
  "MarketView.loading": "Carregando...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Falha ao renderizar esta aba",
  "MarketView.unknownError": "Erro desconhecido",

  // ===== Common i18n =====
  "Common.refresh": "Atualizar",
  "Common.toggleSeriesVisibility": "Alternar esta série",
  "Common.error": "Erro",
  "Common.dataUpdateTime": "Hora de atualização dos dados",
  "Common.loading": "Carregando...",
  "Common.noDataSource": "Sem dados (fonte de dados não fornecida)",

  // ===== Common ranges =====
  "Common.to": "a",
  "Common.clear": "Limpar",
  "Common.range.thisMonth": "Este mês",
  "Common.range.lastMonth": "Mês passado",
  "Common.range.last2": "Últimos 2 meses",
  "Common.range.last3": "Últimos 3 meses",
  "Common.range.last6": "Últimos 6 meses",
  "Common.range.thisYear": "Este ano",
  "Common.range.all": "Todos",
  "Common.range.custom": "Personalizado",
  "Common.showFilters": "Mostrar filtros",
  "Common.hideFilters": "Ocultar filtros",
  "Common.search": "Pesquisar",
  "Common.priority": "Prioridade",
  "Common.owner": "Responsável",
  "Common.collaborator": "Colaborador",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Baixar backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Baixar youtube_stats.json",
  "YouTubeTab.loading": "Carregando métricas do YouTube...",
  "YouTubeTab.errorHint":
    "Se a chave de API não estiver configurada, defina YOUTUBE_API_KEY ou GOOGLE_API_KEY em backend/.env e reinicie o backend.",
  "YouTubeTab.header.totalViews":
    "Visualizações totais (multi-canal, unidade: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Inscritos totais (multi-canal, unidade: 10k)",
  "YouTubeTab.dist.views": "Distribuição de visualizações (10k)",
  "YouTubeTab.dist.subscribers": "Distribuição de inscritos (10k)",
  "YouTubeTab.card.location": "Localização:",
  "YouTubeTab.card.registeredAt": "Cadastrado em:",
  "YouTubeTab.card.currentSubscribers": "Inscritos atuais",
  "YouTubeTab.card.currentVideos": "Quantidade de vídeos atual",
  "YouTubeTab.card.currentTotalViews": "Visualizações totais atuais",
  "YouTubeTab.card.currentTotalComments": "Comentários totais atuais",
  "YouTubeTab.chart.totalSubscribers": "Inscritos totais",
  "YouTubeTab.chart.totalViews": "Visualizações totais",
  "YouTubeTab.chart.totalComments": "Comentários totais",
  "YouTubeTab.chart.totalVideos": "Vídeos totais",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Baixar backend data/x_stats.json",
  "XTab.downloadJson": "Baixar x_stats.json",
  "XTab.loading": "Carregando métricas do X...",
  "XTab.errorHint":
    "Se o token não estiver configurado, defina X_BEARER_TOKEN ou TWITTER_BEARER_TOKEN em backend/.env e reinicie o backend.",
  "XTab.header.totalFollowers": "Seguidores totais (multi-canal, unidade: 10k)",
  "XTab.header.totalEngagement":
    "Engajamento total (últimos 5 posts: Curtidas + Retuítes + Respostas + Citações, unidade: 10k)",
  "XTab.dist.followers": "Distribuição de seguidores (10k)",
  "XTab.dist.engagement":
    "Distribuição de engajamento (últimos 5 posts: Curtidas + Retuítes + Respostas + Citações, unidade: 10k)",
  "XTab.card.currentFollowers": "Seguidores atuais",
  "XTab.card.currentFollowing": "Seguindo atualmente",
  "XTab.card.currentTweets": "Quantidade de tweets atual",
  "XTab.card.recentLikes": "Curtidas recentes (últimos 5 posts)",
  "XTab.card.recentRetweets": "Retuítes recentes (últimos 5 posts)",
  "XTab.card.recentReplies": "Respostas recentes (últimos 5 posts)",
  "XTab.card.recentQuotes":
    "Visualizações recentes (nível de conteúdo, últimos 5 posts)",
  "XTab.card.listed": "Listados (nível de canal)",
  "XTab.smallChart.followers": "Seguidores",
  "XTab.smallChart.tweets": "Tweets",
  "XTab.smallChart.likes": "Curtidas recentes",
  "XTab.smallChart.retweets": "Retuítes recentes",
  "XTab.smallChart.replies": "Respostas recentes",
  "XTab.smallChart.quotes": "Visualizações recentes (nível de conteúdo)",
  "XTab.smallChart.following": "Seguindo",
  "XTab.smallChart.listed": "Listados",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Filtrar por mês de criação:",
  "Analytics.dashboardTitle": "Painel de saúde do projeto",
  "Analytics.metric.completionRate": "Taxa de conclusão",
  "Analytics.metric.teamVelocity": "Velocidade da equipe",
  "Analytics.metric.blockerRatio": "Proporção de bloqueios",
  "Analytics.metric.workloadBalance": "Equilíbrio de carga de trabalho",
  "Analytics.charts.statusDistribution": "Distribuição de status",
  "Analytics.charts.statusByMonthPercent": "Status por mês (porcentagem)",
  "Analytics.charts.priorityDistribution": "Distribuição de prioridades",
  "Analytics.charts.priorityByMonthPercent":
    "Prioridades por mês (porcentagem)",
  "Analytics.charts.functionTypeDistribution":
    "Distribuição por tipo de função",
  "Analytics.charts.functionTypeByMonthPercent":
    "Tipo de função por mês (porcentagem)",
  "Analytics.blocker.ownerPie":
    "Problemas bloqueados · Distribuição por responsável (rosquinha)",
  "Analytics.blocker.ownerByMonth":
    "Problemas bloqueados · Responsável por mês (porcentagem)",
  "Analytics.bug.ownerPie":
    "Problemas de bug · Distribuição por responsável (rosquinha)",
  "Analytics.bug.ownerByMonth":
    "Problemas de bug · Responsável por mês (porcentagem)",
  "Analytics.ownerWorkloadDistribution":
    "Distribuição da carga de trabalho da equipe",
  "Analytics.mode.priority": "Distribuição de prioridades",
  "Analytics.mode.status": "Distribuição de status",
  "Analytics.mode.type": "Distribuição de tipos",
  "Analytics.blocker.attentionNeeded":
    "Problemas que requerem atenção imediata",
  "Analytics.common.status": "Status",
  "Analytics.common.owner": "Responsável",
  "Analytics.insights.sectionTitle": "Insights e recomendações",
  "Analytics.insights.efficiency.title": "Sugestões de melhoria de eficiência",
  "Analytics.insights.efficiency.completionRate":
    "• A taxa de conclusão atual é {{rate}}%, monitore os bloqueios",
  "Analytics.insights.efficiency.avgVelocity":
    "• A velocidade média da equipe é {{velocity}} tarefas/pessoa",
  "Analytics.insights.efficiency.workloadBalance":
    "• O equilíbrio de carga é {{balance}}%",
  "Analytics.insights.risk.title": "Alertas de risco",
  "Analytics.insights.risk.blockerRatio": "• Proporção de bloqueios {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Proporção de issues P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Trate primeiro os problemas de alta prioridade",

  // ===== Kanban i18n =====
  "Kanban.title": "Visão Kanban",
  "Kanban.totalIssues": "Total de {{count}} issues",
  "Kanban.searchPlaceholder":
    "Pesquisar título, número do issue, responsável ou colaboradores...",
  "Kanban.status.backlog": "Backlog",
  "Kanban.status.inProgress": "Em andamento",
  "Kanban.status.blocked": "Bloqueado / Aguardando confirmação",
  "Kanban.status.reviewTest": "Revisão / Teste",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Lista de issues",
  "List.totalIssues": "Total de {{count}} issues",
  "List.viewDetails": "Ver detalhes",
  "List.openInNewWindow": "Abrir em nova janela",
  "List.empty.title": "Sem issues",
  "List.empty.subtitle":
    "Crie o primeiro issue para iniciar seu fluxo de trabalho",

  // ===== Assets Register i18n =====
  "Assets.title": "Registro de ativos",
  "Assets.totalSets": "Conjuntos totais",
  "Assets.table.employee": "Funcionário",
  "Assets.table.setCount": "Conjuntos",
  "Assets.table.model": "Modelo",
  "Assets.total": "Total",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Acompanhamento de issues do projeto",
  "LukkeyIssues.goToDemo": "Ir para a página de demonstração",
  "LukkeyIssues.githubProject": "Projeto no GitHub ↗",
  "LukkeyIssues.githubManageIssues": "Gerenciar Issues diretamente no GitHub ↗",
  "LukkeyIssues.financeModel": "Modelo financeiro",
  "LukkeyIssues.productCoreIssues": "Problemas centrais do produto",
  "LukkeyIssues.stats.totalIssues": "📊 Total de issues",
  "LukkeyIssues.stats.completed": "✅ Concluídos",
  "LukkeyIssues.stats.inProgress": "🔄 Em andamento",
  "LukkeyIssues.stats.pending": "⏳ Pendentes",
  "LukkeyIssues.stats.blocked": "🚫 Bloqueados",
  "LukkeyIssues.stats.docs": "📚 Docs",
  "LukkeyIssues.tabs.kanban": "Visão Kanban",
  "LukkeyIssues.tabs.analytics": "Análises",
  "LukkeyIssues.tabs.market": "Painel de mercado",
  "LukkeyIssues.tabs.assets": "Registro de ativos",
  "LukkeyIssues.shareToChatGPT": "Abrir LUKKEY.json com o ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Política de Privacidade da LUKKEY",
  "PrivacyPolicy.intro.p1":
    "Na LUKKEY, acreditamos que a forma mais segura de privacidade é aquela que permanece sempre nas mãos do próprio usuário.",
  "PrivacyPolicy.intro.p2":
    "Portanto, seja utilizando o hardware de carteira fria (cold wallet) LUKKEY ou o aplicativo móvel LUKKEY (App), seguimos rigorosamente um princípio inabalável:",
  "PrivacyPolicy.intro.p3_strong":
    "Salvo autorização explícita do usuário, não coletamos, não armazenamos e não enviamos nenhuma informação do usuário.",
  "PrivacyPolicy.intro.p3_tail":
    "Todos os dados relacionados ao uso ficam armazenados somente de forma local no dispositivo do usuário e nunca são transmitidos à LUKKEY ou a qualquer servidor.",
  "PrivacyPolicy.intro.p4":
    "Esta Política de Privacidade explica como sustentamos esse princípio.",

  "PrivacyPolicy.s1.title": "1. Escopo de Aplicação",
  "PrivacyPolicy.s1.appliesTo": "Esta Política de Privacidade se aplica a:",
  "PrivacyPolicy.s1.item.hardware": "Hardware de carteira fria LUKKEY",
  "PrivacyPolicy.s1.item.app": "Aplicativo móvel LUKKEY (App)",
  "PrivacyPolicy.s1.principle":
    "Ambos seguem o princípio unificado de “zero coleta, zero envio, armazenamento somente local”.",

  "PrivacyPolicy.s2.title": "2. Informações que NÃO coletamos",
  "PrivacyPolicy.s2.desc":
    "Para proteger sua privacidade, comprometemo-nos explicitamente a não coletar, enviar ou armazenar qualquer informação do usuário, incluindo mas não se limitando a:",
  "PrivacyPolicy.s2.li.identity":
    "Informações de identidade: nome, número de telefone, endereço de e-mail, endereço postal",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Dados sensíveis da carteira: chaves privadas, frases mnemônicas, arquivos keystore, senhas da carteira",
  "PrivacyPolicy.s2.li.blockchain":
    "Dados de blockchain: endereços de carteira, histórico de transações, informações de ativos",
  "PrivacyPolicy.s2.li.behavior":
    "Comportamento de uso: logs do app, registros de cliques, análise comportamental",
  "PrivacyPolicy.s2.li.technical":
    "Informações técnicas: identificadores do dispositivo, geolocalização, endereço IP",
  "PrivacyPolicy.s2.inShort.title": "Em resumo:",
  "PrivacyPolicy.s2.inShort.desc":
    "Tudo o que você vê no dispositivo físico e no App existe apenas no seu dispositivo. A LUKKEY não tem acesso.",

  "PrivacyPolicy.s3.title":
    "3. Design de Privacidade e Segurança da Carteira Fria (Hardware)",
  "PrivacyPolicy.s3.desc":
    "A carteira fria da LUKKEY oferece um ambiente totalmente offline e seguro. Principais recursos:",
  "PrivacyPolicy.s3.h1.title": "1. Hardware de segurança em nível militar",
  "PrivacyPolicy.s3.h1.l1": "Secure Element com certificação EAL6+",
  "PrivacyPolicy.s3.h1.l2":
    "Comunicação criptografada em nível de hardware em toda a cadeia",
  "PrivacyPolicy.s3.h2.title": "2. Funções de segurança",
  "PrivacyPolicy.s3.h2.l1": "Autenticação por impressão digital",
  "PrivacyPolicy.s3.h2.l2": "Modo de privacidade",
  "PrivacyPolicy.s3.h2.l3": "Gestão isolada de múltiplas carteiras",
  "PrivacyPolicy.s3.h3.title": "3. Isolamento completo",
  "PrivacyPolicy.s3.h3.l1": "Sem conectividade com a Internet",
  "PrivacyPolicy.s3.h3.l2": "Sem conexão por cabo de dados",
  "PrivacyPolicy.s3.h4.title": "4. Autodestruição à prova de violação",
  "PrivacyPolicy.s3.h4.desc":
    "Se o dispositivo for desmontado, danificado ou sofrer intrusão anormal, o Secure Element destrói automaticamente os dados sensíveis para garantir que as chaves privadas não possam ser extraídas.",
  "PrivacyPolicy.s3.h5.title":
    "5. Operações sensíveis realizadas apenas dentro do Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Criação de carteira",
  "PrivacyPolicy.s3.h5.l2": "Importação de carteira",
  "PrivacyPolicy.s3.h5.l3": "Assinatura de transações",
  "PrivacyPolicy.s3.h5.note":
    "Todos os processos sensíveis ocorrem 100% dentro do Secure Element, sem exposição a chips ou áreas de armazenamento não seguras.",
  "PrivacyPolicy.s3.h6.title": "6. Nenhum dado sensível fora do Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "As áreas de armazenamento não seguras do dispositivo nunca armazenam chaves privadas, frases mnemônicas ou informações sensíveis.",

  "PrivacyPolicy.s4.title":
    "4. Design de Privacidade e Segurança do App LUKKEY",
  "PrivacyPolicy.s4.desc":
    "O App LUKKEY foca exclusivamente na exibição de informações e no fornecimento de notificações. Ele não lida com dados sensíveis da carteira.",
  "PrivacyPolicy.s4.n1.title": "1. O que o App NÃO faz",
  "PrivacyPolicy.s4.n1.l1": "Não gera carteiras blockchain",
  "PrivacyPolicy.s4.n1.l2": "Não importa carteiras blockchain",
  "PrivacyPolicy.s4.n1.l3": "Não armazena chaves privadas ou frases mnemônicas",
  "PrivacyPolicy.s4.n1.l4": "Não envia quaisquer dados do usuário",
  "PrivacyPolicy.s4.n1.l5":
    "Não realiza análise comportamental, rastreamento publicitário ou coleta de dados",
  "PrivacyPolicy.s4.n2.title": "2. O que o App FAZ",
  "PrivacyPolicy.s4.n2.l1":
    "Exibe informações de acesso público autorizadas pelo hardware",
  "PrivacyPolicy.s4.n2.l2":
    "Fornece um painel de privacidade explicando a finalidade de cada permissão",
  "PrivacyPolicy.s4.n2.l3":
    "Garante controle total ao usuário para ativar/desativar permissões a qualquer momento",
  "PrivacyPolicy.s4.n2.l4": "Oferece mascaramento de informações sensíveis",
  "PrivacyPolicy.s4.n2.l5":
    "Desativa captura de tela/gravação em determinadas telas",
  "PrivacyPolicy.s4.n2.l6":
    "Detecta endereços blockchain suspeitos por meio de correspondência local",
  "PrivacyPolicy.s4.n2.l7":
    "Atualiza regularmente URLs, contratos e endereços perigosos",
  "PrivacyPolicy.s4.n2.l8":
    "Fluxo de atualização unidirecional: apenas do servidor → para o dispositivo",
  "PrivacyPolicy.s4.n2.l9":
    "Nenhum dado do usuário é enviado de volta durante as atualizações",
  "PrivacyPolicy.s4.n3.title": "3. Armazenamento local",
  "PrivacyPolicy.s4.n3.p1":
    "O App armazena localmente apenas dados não privados, como preferências de interface, idioma e tema. Esses dados:",
  "PrivacyPolicy.s4.n3.l1": "não são enviados",
  "PrivacyPolicy.s4.n3.l2": "não são sincronizados",
  "PrivacyPolicy.s4.n3.l3": "não são acessíveis à LUKKEY",

  "PrivacyPolicy.s5.title": "5. Transmissão de Dados e Política de Servidores",
  "PrivacyPolicy.s5.l1":
    "Os servidores da LUKKEY não armazenam quaisquer informações de usuários",
  "PrivacyPolicy.s5.l2":
    "A comunicação App–servidor limita-se a atualizações de banco de dados e de versão",
  "PrivacyPolicy.s5.l3":
    "Nenhuma informação do usuário é transmitida durante a comunicação",
  "PrivacyPolicy.s5.l4":
    "Mesmo em caso de invasão de servidor, nenhum dado do usuário poderia ser exposto, pois nunca obtemos tais dados",

  "PrivacyPolicy.s6.title": "6. Transparência Open Source",
  "PrivacyPolicy.s6.l1": "O código-fonte do App LUKKEY é open source",
  "PrivacyPolicy.s6.l2":
    "O firmware embarcado do hardware LUKKEY é open source",
  "PrivacyPolicy.s6.l3":
    "Totalmente disponível no GitHub para auditoria por qualquer pessoa",
  "PrivacyPolicy.s6.p": "Transparência é parte da segurança.",

  "PrivacyPolicy.s7.title": "7. Controle total do usuário",
  "PrivacyPolicy.s7.p":
    "Embora não coletemos informações do usuário, os usuários mantêm controle total sobre seus dispositivos:",
  "PrivacyPolicy.s7.l1":
    "Você pode desativar permissões do App a qualquer momento",
  "PrivacyPolicy.s7.l2":
    "Você pode desinstalar o App para remover todos os dados locais do aplicativo",
  "PrivacyPolicy.s7.l3":
    "Você pode redefinir o dispositivo de hardware para apagar permanentemente chaves privadas e dados da carteira",
  "PrivacyPolicy.s7.p2":
    "A LUKKEY não intervém e não pode intervir nessas ações.",

  "PrivacyPolicy.s8.title": "8. Fale conosco",
  "PrivacyPolicy.s8.p":
    "Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato:",
  "PrivacyPolicy.s8.email": "E-mail: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Endereço: Sede da LUKKEY, Baarerstrasse 25, 6300 Zug, Suíça",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Verificando...",
  "EmailOtp.title":
    "Acesso restrito: informe nome e e‑mail para receber um código de login",
  "EmailOtp.nameLabel": "Nome",
  "EmailOtp.namePlaceholder": "Informe seu nome",
  "EmailOtp.emailLabel": "E‑mail",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Enviar código",
  "EmailOtp.resendCode": "Reenviar código",
  "EmailOtp.resendWithCountdown": "Reenviar ({{s}}s)",
  "EmailOtp.codeValidityHint":
    "O código de verificação é válido por cerca de 10 minutos",
  "EmailOtp.codeLabel": "Código de verificação por e‑mail",
  "EmailOtp.codePlaceholder": "Digite o código recebido",
  "EmailOtp.signIn": "Entrar",
  "EmailOtp.message.codeSent":
    "Código de verificação enviado, verifique sua caixa de entrada",
  "EmailOtp.error.nameRequired": "Informe seu nome",
  "EmailOtp.error.invalidEmail": "Informe um endereço de e‑mail válido",
  "EmailOtp.error.sendFailed":
    "Falha ao enviar o código de verificação. Tente novamente mais tarde.",
  "EmailOtp.error.codeRequired": "Digite o código de verificação",
  "EmailOtp.error.verificationFailed": "Falha na verificação",
  // ===== Academy i18n =====
  "Academy.hero.alert": "Aviso de segurança: sempre verifique links e nunca compartilhe sua frase de recuperação.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Academia",
  "Academy.hero.subtitle": "Guias práticos sobre segurança cripto, autocustódia e uso da cold wallet LUKKEY.",
  "Academy.search.placeholder": "Buscar tutoriais, boas práticas e FAQs…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "ARTIGO",
  "Academy.list.title": "Guias mais recentes",
  "Academy.list.viewAll": "VER TUDO",
  "Academy.list.empty": "Sem resultados. Tente outra palavra‑chave.",
  "Academy.image.placeholder": "IMAGEM",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Voltar à Academia",
  "AcademyArticle.notFound": "Artigo não encontrado",
  "AcademyArticle.author": "Autor",
  "AcademyArticle.unscheduled": "Sem horário de publicação agendado",
  "home.hero.reserveCtaLabel": "Acesso antecipado — US$ 1",
  "home.hero.reserveCtaNote": "Totalmente reembolsável. Sem compromisso de compra."
};
export default translation;
